const isReportOnlyEmailEvent = (row = {}) =>
  row.emailTriggerEligible === false ||
  (
    row.eventFamily === 'enrollment_status_observation' &&
    row.eventAction === 'report_only_null_to_in_progress'
  );

const isEmailRowActionAllowed = (row, actionType) =>
  !['execute_trigger', 'force_edit_trigger'].includes(actionType) ||
  !isReportOnlyEmailEvent(row);

export {
  isEmailRowActionAllowed,
  isReportOnlyEmailEvent,
};
